import { Text, Tooltip } from '@talos/kyoko';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

export const ToastDate = ({ timeStamp }: { timeStamp: string }) => {
  const [dateToShow, setDateToShow] = useState(() => formatToastDate(timeStamp));

  useEffect(() => {
    const interval = setInterval(() => {
      setDateToShow(formatToastDate(timeStamp));
    }, 10_000);
    return () => clearInterval(interval);
  }, [timeStamp]);

  return (
    <Tooltip tooltip={new Date(timeStamp).toLocaleString()} placement="top">
      <Text>{dateToShow}</Text>
    </Tooltip>
  );
};

const oneDayInSeconds = 86400;
const oneHourInSeconds = 3600;
function formatToastDate(timeStamp: string): string {
  const date = new Date(timeStamp);
  // If timeStamp < 1 minute, show 'Now';
  // If timeStamp < 1 hour, show 'Xm';
  // If timestamp < 1 day, show 'Xh Xm';
  // If timestamp >= 1 day, show 'MMM dd'
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  if (diffInSeconds < 60) {
    return 'Now';
  }
  if (diffInSeconds < oneHourInSeconds) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes}m ago`;
  }
  if (diffInSeconds < oneDayInSeconds) {
    const hours = Math.floor(diffInSeconds / oneHourInSeconds);
    return `${hours}h ago`;
  }
  return format(date, 'MMM dd');
}
